import React, { useState, useRef } from 'react';
import img from '../assest/Final.png';

const Hero: React.FC = () => {
  const formRef = useRef<HTMLFormElement>(null);
  const [mobileNumber, setMobileNumber] = useState('');
  const [whatsappNumber, setWhatsappNumber] = useState('');
  const [isSame, setIsSame] = useState(false);
  const [showModal, setShowModal] = useState(false); // Wahi original state name

  // --- NAYA CODE YAHAN ADD KARO ---
  const [selectedDate, setSelectedDate] = useState('');
  
  // Aaj ki date aur current ghanta (hour) nikalne ke liye
  const today = new Date().toISOString().split('T')[0]; // Output: '2026-02-23'
  const currentHour = new Date().getHours(); // Output: 0 se 23 ke beech (24-hour format)
  // --------------------------------

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const checked = e.target.checked;
    setIsSame(checked);
    if (checked) setWhatsappNumber(mobileNumber);
  };

  // Tumhara Original Submit Logic
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);
    const data = {
      full_name: formData.get('full_name'),
      user_email: formData.get('user_email'),
      school_name: formData.get('school_name'),
      contact_number: mobileNumber,
      whatsapp_number: whatsappNumber,
      contact_person: formData.get('contact_person'),
      course: formData.get('course'),
      studentClass: formData.get('studentClass'),
      date: formData.get('date'),
      time_slot: formData.get('time_slot'),
    };

    try {
      const response = await fetch('http://api.bestcoachinginjalandhar.com/api/enquiry', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      });
      if (response.ok) {
        setShowModal(true); // Tumhara original popup logic
        formRef.current?.reset();
        setMobileNumber('');
        setWhatsappNumber('');
        setIsSame(false);
        setSelectedDate('');
      } else {
        alert("Something went wrong! Server responded with status: " + response.status);
      }
    } catch (err) {
      alert("Failed to connect to server. Check if backend is running.");
    }
  };

  return (
    // DESIGN: New "Red Background + Overlap" Style
    <section className="relative w-full min-h-[92vh] flex flex-col lg:flex-row overflow-x-hidden bg-[#9e1c22]">
      
      {/* FUNCTIONALITY: Tumhara Original Popup Logic */}
    {showModal && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
          <div className="bg-white rounded-2xl p-8 max-w-sm w-full text-center shadow-2xl animate-in fade-in zoom-in duration-300">
            <div className="w-16 h-16 bg-green-100 text-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <h2 className="text-2xl font-bold text-gray-800 mb-2">Thank You!</h2>
            <p className="text-gray-600 mb-6 text-sm">
              Your enquiry has been successfully submitted. Our expert counselor will connect with you shortly to assist you further.
            </p>
            <button 
              onClick={() => setShowModal(false)}
              className="w-full bg-[#9e1c22] text-white py-3 rounded-xl font-bold hover:bg-red-800 transition-colors"
            >
              Close
            </button>
          </div>
        </div>
      )}

      {/* --- LEFT SIDE: Solid Red Background Container --- */}
      <div className="relative w-full lg:w-[40%] bg-[#9e1c22] flex items-center justify-center p-6 lg:p-12 z-20 animate-[slideInLeft_1s_ease-out_forwards]">
        
        {/* Form Card with Overlap Margin (lg:-mr-20) */}
        <div className="relative z-30 w-full max-w-md bg-white rounded-2xl shadow-[0_30px_70px_-15px_rgba(0,0,0,0.5)] overflow-hidden border-2 border-white/20 mr-0 lg:-mr-20">
            <div className="bg-gray-50 border-b border-gray-100 p-4 text-center">
               <h3 className="text-[#9e1c22] font-black text-xl uppercase tracking-tight">Get Expert Counseling</h3>
               <p className="text-gray-500 text-xs mt-0.5 font-bold">Fill the form to book your free slot</p>
            </div>

            <form ref={formRef} className="p-6 space-y-4" onSubmit={handleSubmit}>
              <div className="space-y-3">
                <input name="full_name" type="text" placeholder="Student's Name" className="form-input" required />
                <input name="user_email" type="email" placeholder="Email Address" className="form-input" required />
                <input name="school_name" type="text" placeholder="School Name" className="form-input" required />
              </div>

              <div className="flex gap-2">
                <span className="flex items-center justify-center rounded border border-gray-200 bg-gray-50 px-3 text-xs font-bold text-gray-500">IN +91</span>
                <input 
                  type="tel" 
                  placeholder="Mobile Number" 
                  className="form-input flex-1" 
                  value={mobileNumber} 
                  onChange={(e) => { 
                    setMobileNumber(e.target.value); 
                    if (isSame) setWhatsappNumber(e.target.value); 
                  }} 
                  required 
                />
              </div>

              <div className="space-y-1">
                <div className="flex justify-end">
                   <label className="flex items-center gap-1.5 cursor-pointer select-none hover:opacity-80">
                    <input type="checkbox" className="w-3.5 h-3.5 accent-[#9e1c22] rounded" checked={isSame} onChange={handleCheckboxChange} />
                    <span className="text-[10px] font-bold text-[#9e1c22]">Same as Mobile</span>
                  </label>
                </div>
                <div className="flex gap-2">
                  <span className="flex items-center justify-center rounded border border-gray-200 bg-gray-50 px-3 text-xs font-bold text-gray-500">IN +91</span>
                  <input 
                    type="tel" 
                    placeholder="WhatsApp Number" 
                    className={`form-input flex-1 ${isSame ? 'bg-gray-100 text-gray-400' : ''}`} 
                    value={whatsappNumber} 
                    onChange={(e) => setWhatsappNumber(e.target.value)} 
                    disabled={isSame} 
                    required 
                  />
                </div>
              </div>

              <input name="contact_person" type="text" placeholder="Parent/Guardian Name" className="form-input" required />

              <div className="grid grid-cols-2 gap-3">
                <select name="course" className="form-select text-gray-600"><option value="">Course</option><option>IIT-JEE</option><option>NEET</option><option>Foundation</option></select>
                <select name="studentClass" className="form-select text-gray-600"><option value="">Class</option><option>9th</option><option>10th</option><option>11th</option><option>12th</option></select>
              </div>

             <div className="grid grid-cols-2 gap-3">
                 <input 
                   name="date" 
                   type="date" 
                   min={today} // Ye past dates ko disable kar dega
                   value={selectedDate}
                   onChange={(e) => setSelectedDate(e.target.value)}
                   className="form-input text-gray-500 text-[11px]" 
                   required 
                 />
                 <select name="time_slot" className="form-select text-gray-600" required>
                   <option value="">Time Slot</option>
                   
                   {/* Agar aaj ki date hai aur 12 PM (12) se zyada time ho gaya, toh disable */}
                   <option value="Morning (10-1)" disabled={selectedDate === today && currentHour >= 12}>
                     Morning (10-1)
                   </option>
                   
                   {/* Agar aaj ki date hai aur 4 PM (16) se zyada time ho gaya, toh disable */}
                   <option value="Afternoon (1-4)" disabled={selectedDate === today && currentHour >= 16}>
                     Afternoon (1-4)
                   </option>
                   
                   {/* Agar aaj ki date hai aur 7 PM (19) se zyada time ho gaya, toh disable */}
                   <option value="Evening (4-7)" disabled={selectedDate === today && currentHour >= 19}>
                     Evening (4-7)
                   </option>
                 </select>
              </div>

              <button type="submit" className="w-full mt-2 bg-[#9e1c22] hover:bg-red-800 text-white font-bold py-3.5 rounded-xl text-sm uppercase tracking-widest shadow-lg transform transition-all active:scale-95">
                Book Free Counselling
              </button>
            </form>
        </div>
      </div>

      {/* --- RIGHT SIDE: IMAGE BACKGROUND --- */}
      <div 
        className="relative w-full lg:w-[70%] lg:-ml-32 h-[50vh] lg:h-auto bg-gray-900 z-10 animate-[slideInRight_1s_ease-out_forwards]"
        style={{ clipPath: "polygon(100% 0, 100% 100%, 40% 100%, 0 0)" }}
      >
        <div className="absolute inset-0 z-0">
             <img
               src={img}
               alt="Background"
               className="w-full h-full object-cover object-top lg:scale-[0.8] lg:translate-x-16 transition-transform duration-700"
             />
             <div className="absolute inset-0 bg-gradient-to-r from-[#9e1c22]/80 via-[#9e1c22]/20 to-transparent"></div>
        </div>

        {/* Content Overlay */}
        <div className="relative z-10 h-full flex flex-col justify-start pt-14 px-8 lg:pl-40 lg:pr-12 text-center lg:text-left animate-[fadeIn_1.2s_ease-out_0.5s_both]">
            <div className="mb-4 inline-block">
                <span className="bg-yellow-400 text-[#9e1c22] text-[11px] font-black uppercase tracking-widest px-4 py-1.5 rounded-full shadow-lg border-2 border-yellow-200">
                ★ Admissions Open 2025-26
                </span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-black text-white leading-[1.1] uppercase tracking-tight drop-shadow-xl">
                PW Achievers <br /> 
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-300 to-yellow-500 drop-shadow-md">
                     Mega Felicitation 2025
                </span>
            </h1>
            
            <p className="mt-4 text-sm md:text-lg font-bold text-gray-100 max-w-md leading-relaxed drop-shadow-md border-l-4 border-yellow-400 pl-4">
                Celebrating Excellence, Unlocking Opportunity! Join the league of toppers and secure your future.
            </p>
        </div>
      </div>

      {/* --- STYLES & ANIMATIONS --- */}
      <style>{`
        .form-input { width: 100%; height: 44px; border-radius: 0.75rem; border: 1px solid #e5e7eb; padding: 0 1rem; font-size: 0.9rem; outline: none; transition: all 0.3s; background-color: #f8fafc; font-weight: 500; color: #333; }
        .form-input:focus { border-color: #9e1c22; background-color: #fff; box-shadow: 0 0 0 4px rgba(158, 28, 34, 0.1); }
        .form-select { width: 100%; height: 44px; border-radius: 0.75rem; border: 1px solid #e5e7eb; padding: 0 0.5rem; font-size: 0.85rem; outline: none; background-color: #f8fafc; font-weight: 500; color: #555; cursor: pointer; }
        .form-select:focus { border-color: #9e1c22; }

        @keyframes slideInLeft { from { transform: translateX(-100%); opacity: 0; } to { transform: translateX(0); opacity: 1; } }
        @keyframes slideInRight { from { transform: translateX(100%); opacity: 0; } to { transform: translateX(0); opacity: 1; } }
        @keyframes fadeIn { from { opacity: 0; transform: translateY(50px); } to { opacity: 1; transform: translateY(0); } }

        @media (max-width: 1024px) {
            .lg\\:w-\\[70\\%\\] { clip-path: none !important; margin-left: 0 !important; width: 100% !important; }
            .lg\\:-ml-32 { margin-left: 0 !important; }
            .lg\\:-mr-20 { margin-right: 0 !important; }
            .lg\\:pl-40 { padding-left: 2rem !important; }
            .lg\\:scale-\\[0.8\\] { transform: none !important; }
            .lg\\:translate-x-16 { transform: none !important; }
        }
      `}</style>
    </section>
  );
};

export default Hero;